import React from 'react';
import { Button } from 'react-bootstrap';

import StrapiText from '../../text/strapi-markdown-text-snippet';

import { FriendlyReminder } from '../../../models/strapi/stateLandingPageQuery';

import * as styles from './friendlyReminderOverlay.module.scss';

interface PropType {
    reminderOverlayOpen: boolean;
    toggleReminderOverlay: () => void;
    data: FriendlyReminder;
}

class FriendlyReminderOverlay extends React.Component<PropType> {
    constructor(props: PropType) {
        super(props);
    }

    componentDidMount() {
        const friendlyReminder: string | null =
            typeof window !== 'undefined' ? window.localStorage.getItem('friendlyReminder') : null;
        if (friendlyReminder !== '1') {
            this.props.toggleReminderOverlay();
        }
    }

    onCloseReminder() {
        typeof window !== 'undefined' ? window.localStorage.setItem('friendlyReminder', '1') : null;
        this.props.toggleReminderOverlay();
    }

    render() {
        return (
            <div>
                {this.props.reminderOverlayOpen && this.props.data ? (
                    <div
                        className={styles.mainOverlay}
                        onClick={(e) => {
                            e.stopPropagation();
                            this.onCloseReminder();
                        }}>
                        <div
                            className={styles.centeredContents}
                            onClick={(e) => {
                                e.stopPropagation();
                            }}>
                            <div
                                style={{
                                    background: `url(${this.props.data.backgroundImage.url}) no-repeat`
                                }}
                                className={styles.backgroundImg}></div>
                            <div className={styles.reminderText}>
                                <StrapiText
                                    data={{
                                        value: this.props.data.content,
                                        fontColor: 'white',
                                        textAlign: 'left',
                                        font: 'tradeGothic'
                                    }}
                                />
                            </div>
                            <div className={styles.buttonDiv}>
                                <Button
                                    className={styles.closeButton}
                                    onClick={() => {
                                        this.onCloseReminder();
                                    }}>
                                    Exit
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default FriendlyReminderOverlay;
